import { favoriteService } from '../_services';

const getDefaultState = () => {
  return {
    mine: {},
    current: {}
  }
}

export const favorites = {
    namespaced: true,
    state: getDefaultState(),
    actions: {
        resetState ({ commit }) {
            commit('resetState')
        },
        getMyFavorites({ commit }, params) {
            commit('getMyFavoritesRequest');
            favoriteService.get(params)
                .then(
                    response => {
                        commit('getMyFavoritesSuccess', response);
                        return response;
                    },
                    error => commit('getMyFavoritesFailure', error)
                );
        },
        addFavorite({ commit }, params) {
            commit('addFavoriteRequest');
            favoriteService.add(params)
                .then(
                    response => commit('addFavoriteSuccess', response),
                    error => commit('addFavoriteFailure', error)
                )
        },
        removeFavorite({ commit }, params) {
            commit('deleteFavoriteRequest');
            favoriteService.remove(params)
                .then(
                    commit('deleteFavoriteSuccess'),
                    error => commit('deleteFavoriteFailure', error)
                )
            return true;
        }
    },
    mutations: {
        resetState (state) {
            Object.assign(state, getDefaultState())
        },
        getMyFavoritesRequest(state) {
            state.mine = { loading: true };
        },
        getMyFavoritesSuccess(state, favorites) {
            state.mine = Object.values(favorites);
        },
        getMyFavoritesFailure(state, error) {
            state.mine = { error };
        },
        addFavoriteRequest(state, favorite) {
            state.current = { loading: true }
        },
        addFavoriteSuccess(state, Favorite) {
            state.current = Favorite;
        },
        addFavoriteFailure(state, error) {
            state.current = { error };
        },
        deleteFavoriteRequest(state) {
            state.current = { loading: true }
        },
        deleteFavoriteSuccess(state) {
            state.current = {};
            return true;
        },
        deleteFavoriteFailure(state, error) {
            state.update = { error };
        }
    }
}